if (typeof JW === 'undefined') JW = {};
JW.SForm = (function ($)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'SFRM';
    _pri.opts = {
        dbg_lvl: 1,
        dist_start_val: 25,       // fallback value for distance slider
        dist_init_val: 25,        // init value for distance slider - filled by quest object or fallback
        hired_start_val: '',      // start val if quest object's hired is empty
        scope_start_val: ''       // start val if quest object's scope is empty
    };

    _pri.page   = null;
    _pri.clsacc = null;
    _pri.$frm   = null;
    _pri.$adv   = null;

    _pri.dist_slider = null;
    _pri.dist_buff = -1;
    _pri.$loc_inp = null;
    _pri.loc_buff = null;
    _pri.$dist_inp = null;        // dist slider input
    _pri.$lnk_locate = null;
    _pri.$lnk_reset = null;
    //_pri.job_scope_select = null; // job scope select
    _pri.sbtn_html = '<i class="fa fa-search fa-fw" aria-hidden="true"></i><span class="sr-only">Jobs suchen</span>';
    _pri.sbtn_html_load = '<i class="fa fa-refresh fa-spin fa-fw" aria-hidden="true"></i><span class="sr-only">Daten werden geladen</span>';
    _pri.$sbtn = null;

    _pri.qo = null;               // quest object
    _pri.jobs_cache = {};

    _pri.inited = false;
    _pri.inited_hired = false;
    _pri.inited_scope = false;
    _pri.inited_advanced = false;

    _pri.frm_sections = [
        'loc', 'txt', 'dist', 'cl_scopes', 'cl_profs', 'cl_times', 'cl_hireds', 'cl_poss', 'cl_tags', 'rpp', 'pcur'
    ];

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    publ.init = function()
    {
        _pri.dbg('******** init()');

        if (_pri.inited)
        {
            return;
        }
        _pri.inited = true;

        _pri.page = JW.Page;
        _pri.$frm = $('#sfrm');
        if (_pri.$frm.length == 0)
        {
            _pri.dbg('    no #form - exit');
            _pri.$frm = null;
            return;
        }

        _pri.$adv = $('#adv');
        if (_pri.$adv.length > 0)
        {
            var $acc = _pri.$adv.find('.acc-cls');
            if (1 == $acc.length)
            {
                _pri.clsacc = JW.ClsAcc(jQuery, $acc[0]);
            }
            else
            {
                _pri.dbg('    no acc-cls - exit');
                return;
            }
        }

        _pri.qo = _pri.$frm.data('qo');
        _pri.dbg('_pri.qo (form data qo): ', _pri.qo);
        if (typeof _pri.qo !== 'object')
        {
            _pri.qo = _pri.getDefaultQO();
        }

        _pri.$sbtn       = $('.sbtn');
        _pri.$rbtn       = $('.sreset');
        _pri.$loc_inp    = $('#ql');
        _pri.$txt_inp    = $('#qt');

        // _pri.$lnk_locate = $('#lnk-locate');
        // _pri.$lnk_locate.click(_pri.locate);

        _pri.$rbtn.on('click', _pri.resetForm);
        _pri.$sbtn.on('click', _pri.formSubmit);
        $('a.qpager').on('click', _pri.setPCur);
        $('select.qpager:not(.jtp)').on('change', _pri.setRPP);
        $('select.qpager.jtp').on('change', _pri.setJTP);
        $('.gll-scope').on('click', _pri.setGllScope);

        _pri.$loc_inp.on('keydown', _pri.inpKeyDown);
        _pri.$txt_inp.on('keydown', _pri.inpKeyDown);

        _pri.page.trigger('module:init_done', {mod: _pri.cname});
    };

    _pri.inpKeyDown = function(e)
    {
        //_pri.dbg('*** _pri.$inp on keydown');
        var kc = e.keyCode;
        if (kc == 13)
        {
            e.preventDefault();
            _pri.formSubmit();
            return false;
        }
    };

    _pri.setPCur = function(e)
    {
        e.preventDefault();
        _pri.dbg('*** setPCur()');
        var href = $(this).attr('href') ;
        if (typeof href !== 'undefined')
        {
            href = parseInt(href);
            if (href > 0 && href != parseInt(_pri.qo.pcur))
            {
                _pri.qo.pcur = href;
                _pri.formSubmit();
            }
        }
        return false;
    };

    _pri.setRPP = function(e)
    {
        e.preventDefault();
        _pri.dbg('*** setRPP()');
        var val = $(this).val() ;
        if (typeof val !== 'undefined')
        {
            val = parseInt(val);
            if (val > 0 && val != parseInt(_pri.qo.rpp))
            {
                _pri.qo.rpp = val;
                _pri.formSubmit();
            }
        }
        return false;
    };

    _pri.setJTP = function(e)
    {
        e.preventDefault();
        _pri.dbg('*** setJTP()');
        var val = $(this).val() ;
        if (typeof val !== 'undefined')
        {
            val = parseInt(val);
            if (val > 0 && val != parseInt(_pri.qo.pcur))
            {
                _pri.qo.pcur = val;
                _pri.formSubmit();
            }
        }
        return false;
    };

    _pri.setGllScope = function(e)
    {
        e.preventDefault();
        var $this = $(this);
        var scope = $this.data('scope');

        _pri.$frm.find('input[type="checkbox"][name="cl_scopes"]:checked').prop('checked', false);
        _pri.$frm.find('input[type="checkbox"][name="cl_scopes"][value="' + scope + '"]').prop('checked', true);

        _pri.formSubmit();
        return false;
    };

    publ.initQuest = function()
    {
        if (_pri.qo != null && typeof _pri.qo.lat !== 'undefined' && typeof _pri.qo.lng !== 'undefined' && typeof _pri.qo.loc !== 'undefined' && _pri.qo.loc != '')
        {
            _pri.page.trigger('geoc:set_ll_to_name_done', {nm: _pri.qo.loc, ll: L.latLng(_pri.qo.lat, _pri.qo.lng)});
        }
        else
        {
            JW.GeoC.locate();
        }
    };

    publ.tests = function()
    {
        _pri.getFormData();
    };

    _pri.getFormData = function()
    {
        _pri.dbg('******** getFormData()');

        var form_data = _pri.clsacc.getFormData();
        form_data.loc = _pri.$loc_inp.val();
        form_data.txt = _pri.$txt_inp.val();

        return form_data;
    };

    _pri.isLocBufNm = function(nm)
    {
        if (_pri.loc_buff != null && typeof _pri.loc_buff === 'object' && _pri.loc_buff.hasOwnProperty('nm') && _pri.loc_buff.nm == nm)
        {
            return true;
        }
        return false;
    };

    _pri.formSubmit = function()
    {
        _pri.dbgG('*** formSubmit()');

        var form_data = _pri.getFormData();

        var parts = [];
        var len = _pri.frm_sections.length;
        var i, k;
        for (i = 0; i < len; ++i)
        {
            k = _pri.frm_sections[i];
            if (typeof form_data[k] !== 'undefined' && form_data[k] != '')
            {
                parts.push(encodeURIComponent(form_data[k]));
            }
            else
            {
                switch(k)
                {
                    case 'rpp':
                        parts.push(_pri.qo.rpp);
                    break;
                    case 'pcur':
                        parts.push(_pri.qo.pcur);
                    break;

                    default:
                        parts.push('');
                    break;
                }
            }
        }

        var param = parts.join('|');
        // var param = btoa(param);
        _pri.dbg('    new param:', param);
        _pri.dbg('    cur url:', window.location.href);
        window.location.href = _pri.$frm.data('url') + '?q=' + param;

        return false;
    };

    publ.getJobsToKey = function(k)
    {
        if (_pri.jobs_cache.hasOwnProperty(k))
        {
            return _pri.jobs_cache[k];
        }
        return [];
    }

    _pri.getJobs = function()
    {

        _pri.dbg('******** getJobs() form_data: ', form_data);



        // var pat = /^[1-9]\d*$/;
        // if (form_data.ql != '' && _pri.isLocBufNm(form_data.ql) && pat.test(form_data.qd))
        // {
        //     _pri.page.trigger('sform:loading_jobs');
        //     form_data.lat = _pri.loc_buff.ll.lat;
        //     form_data.lng = _pri.loc_buff.ll.lng;
        //
        //     $.ajax({
        //         type: "POST",
        //         url: _pri.opts.get_jobs_url + '?tkn=' + JW.Page.getUId(32),
        //         contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        //         data: form_data,
        //         dataType: 'json'
        //     }).done(function(ret, stat_str, jq_xhr) {
        //         _pri.dbg('*** getJobs() done');
        //         var jobs_cache_key = JW.Page.getUId();
        //         _pri.jobs_cache = {};
        //         _pri.jobs_cache[jobs_cache_key] = ret;
        //         _pri.page.trigger('sform:loading_jobs_done', {key: jobs_cache_key});
        //     });
        // }
    };

    // _pri.locate = function(e)
    // {
    //     if ('' == _pri.$loc_inp.val() || _pri.sbtn_html != _pri.$sbtn.html())
    //     {
    //         return false;
    //     }
    //
    //
    //     if (typeof e !== 'undefined')
    //     {
    //         e.preventDefault();
    //     }
    //
    //     JW.GeoC.locate();
    // };

    _pri.getDefaultQO = function()
    {
        return {
                    loc:            '',
                    txt:            '',
                    cl_scopes:      _pri.opts.scope_start_val,
                    cl_profs:      '',
                    cl_hireds:     _pri.opts.hired_start_val,
                    cl_times:      '',
                    cl_poss:       '',
                    cl_tags:       '',
                    lat:            0,
                    lng:            0,
                    dist:           _pri.opts.dist_start_val,
                    rpp:            10,
                    pcur:           1

                };
    };

    _pri.resetForm = function(e)
    {
        _pri.dbg('*** resetForm()');
        if (typeof e !== 'undefined')
        {
            e.preventDefault();
        }
        var qo = _pri.getDefaultQO();

        _pri.initFormByQo(qo);

        // JW.GeoC.locate();

        _pri.formSubmit();
        return false;
    };

    _pri.initFormByQo = function(qo)
    {
        _pri.dbg('*** initFormByQo()');
        var len = _pri.frm_sections.length;
        var i, k, val, arr;
        for (i = 0; i < len; ++i)
        {
            k = _pri.frm_sections[i];
            _pri.dbg('    k: ', k);
            if (typeof qo[k] !== 'undefined')
            {
                // 'loc', 'txt', 'dist', 'cl_scopes', 'cl_profs', 'cl_times', 'cl_hireds', 'cl_poss', 'cl_tags', 'rpp', 'pcur'
                val = decodeURIComponent(qo[k]);
                switch (k)
                {
                    case 'loc':
                        _pri.$loc_inp.val(val);
                    break;

                    case 'txt':
                        _pri.$txt_inp.val(val);
                    break;

                    case 'dist':
                        val = parseInt(val);
                        _pri.$frm.find('input[name="dist-inp"]').val(val).trigger('input');
                    break;

                    case 'cl_scopes':
                        _pri.$frm.find('input[type="checkbox"][name="cl_scopes"]:checked').prop('checked', false);
                        if (val != '')
                        {
                            arr = val.split(',');
                            $.each(arr, function(k, v) {
                                _pri.$frm.find('input[type="checkbox"][name="cl_scopes"][value="' + v + '"]').prop('checked', true);
                            });
                        }
                    break;

                    case 'cl_profs':
                        _pri.$frm.find('input[type="checkbox"][name="cl_profs"]:checked').prop('checked', false);
                        if (val != '')
                        {
                            arr = val.split(',');
                            $.each(arr, function(k, v) {
                                _pri.$frm.find('input[type="checkbox"][name="cl_profs"][value="' + v + '"]').prop('checked', true);
                            });
                        }
                    break;

                    case 'cl_times':
                        _pri.$frm.find('input[type="checkbox"][name="cl_times"]:checked').prop('checked', false);
                        if (val != '')
                        {
                            arr = val.split(',');
                            $.each(arr, function(k, v) {
                                _pri.$frm.find('input[type="checkbox"][name="cl_times"][value="' + v + '"]').prop('checked', true);
                            });
                        }
                    break;

                    case 'cl_hireds':
                        _pri.$frm.find('input[type="checkbox"][name="cl_hireds"]:checked').prop('checked', false);
                        if (val != '')
                        {
                            arr = val.split(',');
                            $.each(arr, function(k, v) {
                                _pri.$frm.find('input[type="checkbox"][name="cl_hireds"][value="' + v + '"]').prop('checked', true);
                            });
                        }
                    break;

                    case 'cl_poss':
                        _pri.$frm.find('input[type="checkbox"][name="cl_poss"]:checked').prop('checked', false);
                        if (val != '')
                        {
                            arr = val.split(',');
                            $.each(arr, function(k, v) {
                                _pri.$frm.find('input[type="checkbox"][name="cl_poss"][value="' + v + '"]').prop('checked', true);
                            });
                        }
                    break;

                    case 'cl_tags':
                        var $sel_tags = _pri.$frm.find('select[name="cl_tags"]');
                        $sel_tags.find('option').remove().end();
                        if (val != '')
                        {
                            arr = val.split(',');
                            $.each(arr, function (i, tag) {
                                var tag_dec = decodeURIComponent(tag);
                                $sel_tags.append($('<option>', {
                                    value: tag_dec,
                                    text : tag_dec
                                }));
                            });
                        }
                    break;

                    case 'pcur':
                        _pri.qo.pcur = val;
                    break;

                    case 'rpp':
                        _pri.qo.rpp = val;
                    break;

                    default:

                    break;
                }
            }
        }

        _pri.clsacc.upd();
    };

    _pri.onLocChange = function(e)
    {
        _pri.dbg('******** onLocChange()');
        //var locstr = $(this).val();
        //_pri.dbg(locstr, escape(locstr), encodeURIComponent(locstr));
    };

    _pri.onLocInput = function(e)
    {
        _pri.dbg('******** onLocInput()');
        //var locstr = $(this).val();
        //_pri.dbg(locstr, escape(locstr), encodeURIComponent(locstr));
    };

    _pri.extend();

    // expose public methods
    return publ;
})(jQuery);
